/** The admin area is only offered on the admin subdomain — and on localhost, for development. */
export function isAdminHost(host = window.location.hostname): boolean {
  return host.startsWith('devadmin.') || host === 'localhost' || host === '127.0.0.1'
}
